var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.77101 19.2873C3.2053 19.2873 2.72101 19.0888 2.31815 18.6919C1.9153 18.2949 1.71387 17.8177 1.71387 17.2603V5.09829C1.71387 4.54087 1.9153 4.06368 2.31815 3.66672C2.72101 3.26977 3.2053 3.07129 3.77101 3.07129H20.2282C20.7939 3.07129 21.2782 3.26977 21.681 3.66672C22.0839 4.06368 22.2853 4.54087 22.2853 5.09829V20.8836C22.2853 21.3397 22.0753 21.6564 21.6553 21.8337C21.2353 22.0111 20.8624 21.9393 20.5367 21.6184L18.171 19.2873H3.77101ZM19.0453 17.2603L20.2282 18.4005V5.09829H3.77101V17.2603H19.0453Z",
    fill: "#EDF7EE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2299 8.02242C16.8241 8.63947 17.1431 9.33154 17.1431 10.4534C17.1431 12.4275 15.7263 14.1969 13.6646 15.0717L13.1494 14.2945C15.0733 13.277 15.4494 11.9566 15.6 11.124C15.2902 11.2808 14.8847 11.3356 14.4866 11.2995C13.4459 11.2053 12.6256 10.3699 12.6256 9.33154C12.6256 8.80797 12.8383 8.30585 13.217 7.93563C13.5956 7.56541 14.1092 7.35742 14.6447 7.35742C15.2637 7.35742 15.8561 7.6338 16.2299 8.02242ZM10.4612 8.02242C11.0554 8.63947 11.3744 9.33154 11.3744 10.4534C11.3744 12.4275 9.95756 14.1969 7.8958 15.0717L7.38065 14.2945C9.30453 13.277 9.68066 11.9566 9.83065 11.124C9.52086 11.2808 9.11532 11.3356 8.71785 11.2995C7.67716 11.2058 6.85742 10.3705 6.85742 9.33154C6.85742 8.80797 7.07014 8.30585 7.44879 7.93563C7.82744 7.56541 8.341 7.35742 8.87649 7.35742C9.49548 7.35742 10.0879 7.6338 10.4617 8.02242",
    fill: "#EDF7EE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/quote.07c665d9357a2cf09bd394199ef30295.svg";
export { ForwardRef as ReactComponent };